import React, { FC, useRef } from 'react';

import { useStickyHeader } from '../../predictions/components/sticky-headers';
import { CashFlowGrid } from './cash-flow-grid';

interface Props {
  hideTitle?: boolean;
  isOnReporting?: boolean;
}

export const PredictedCashGrid: FC<Props> = ({ hideTitle, isOnReporting }: Props) => {
  const [headlineHeaderRef, setHeadlineHeaderScroll] = useStickyHeader();
  const tableForwardRef = useRef<HTMLDivElement | null>(null);

  const updateScrollLeft = (scrollLeft: number): void => {
    setHeadlineHeaderScroll(scrollLeft);
    tableForwardRef.current!.scrollLeft = scrollLeft;
  };

  return (
    <CashFlowGrid
      hideTitle={hideTitle}
      isOnReporting={isOnReporting}
      headlineHeaderRef={headlineHeaderRef}
      tableForwardRef={tableForwardRef}
      updateScrollLeft={updateScrollLeft}
    />
  );
};
